module.exports = __webpack_public_path__ + "img/arco.a324878c.jpg";